export default "__VITE_ASSET__ry15Q4s0__"